import { PhysicalInventoryStatus } from './physical-inventory-enums';

export class InventoryPhysicalAdjustmentInfo {

    public reportId: string = '';

    public totalValue?: number = undefined;
    public totalAdjustments: number = 0;
    public reportStatus: PhysicalInventoryStatus = PhysicalInventoryStatus.inProgress;

    public adjustmentGroups: InventoryPhysicalAdjustmentGroup[] = [];
}

export class InventoryPhysicalAdjustmentGroup {
    public id: string = '';
    public reason: string = '';

    public adjustments: InventoryPhysicalAdjustment[] = [];
}

export class InventoryPhysicalAdjustment {
    public partNumber: string = '';
    public serviceCenterId: string = '';
    public description: string = '';
    public unitOfMeasure: string = '';    
    public quantities: number[] = [];

    public quantity1: any;
    public quantity2: any;
    public quantity3: any;
    public quantity4: any;
    public quantity5: any;
    public quantity6: any;
}